import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';

import BusinessService from '@/core/services/business.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateBusinessComponent extends Vue {

  businessService: any = new BusinessService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  genericErr: any = [];
  companyList: any = [];
  name: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  companies: string = "";
  permissions: string = "";

  mounted (){
    const _ = this;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }



  create(){
    const _ = this;
    _.genericErr = [];
    let business = {
      name: _.name
    };
    _.isLoading = true;
    _.businessService.create(business).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.error = false;
        _.isLoading = false;
        _.$router.push('/business');
      }, 2000)
    })
    .catch((err: any) => {
      _.isErrorServer = true;
      _.error = true;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }



  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe el nombre del giro");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
